import axios from "axios";

import { ENDPOINT } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";

/**
 * Resolve the app Itinerary-table PK (`id`, a uuid) from the booking-engine
 * short-code (`itineraryId`) + userId. Used on the post-payment success page to
 * recover the app id when `selectedChatData.id` is empty (the prebook itinerary
 * save raced the Stripe redirect or failed) — so the confirmation email/push
 * deep link is correct. This NEVER creates a row, so there is no duplicate risk,
 * and it is best-effort: a null return must not block booking confirmation.
 */
export async function resolveItineraryIdAPI(
  accessJWT: string,
  itineraryId: string,
  userId: string
): Promise<{ id: string } | null> {
  const URL = `${ENDPOINT}/app/v1/itinerary/resolve-id`;
  const config = getHeaderConfig(null, accessJWT);
  const body = { itineraryId, userId };
  if (!hasUsableJWT(accessJWT, "resolveItineraryIdAPI")) return null;
  if (!itineraryId || !userId) return null;
  try {
    consoleLog(["API REQUEST", URL, body]);
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decrypted = decryptData(response?.data);
      const parsed = decrypted ? JSON.parse(decrypted) : null;
      consoleLog(["API RESPONSE", URL, parsed]);
      if (parsed?.statusCode === 200 && parsed?.data?.id) return parsed.data;
      return null;
    }
    return null;
  } catch (error) {
    consoleLog([error, "resolveItineraryId Error"]);
    return null;
  }
}
